import { CONFERENCE_JOINED } from '../base/conference/actionTypes';
import { participantUpdated } from '../base/participants/actions';
import { getLocalParticipant } from '../base/participants/functions';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
MiddlewareRegistry.register(store => next => action => {
    const result = next(action);
    switch (action.type) {
        case CONFERENCE_JOINED: {
            const state = store.getState();
            const { user_SGI, pwd_SGI, watermark_SGI, relacao_carga_SGI, id_Agendamento, protocolo_ano_SGI } = state['features/base/config'];
            const localParticipant = getLocalParticipant(state);
            if (localParticipant && (user_SGI || pwd_SGI || watermark_SGI || relacao_carga_SGI || id_Agendamento || protocolo_ano_SGI)) {
                store.dispatch(participantUpdated({
                    id: localParticipant.id,
                    user_SGI,
                    pwd_SGI,
                    watermark_SGI,
                    relacao_carga_SGI,
                    id_Agendamento,
                    protocolo_ano_SGI
                }));
            }
            break;
        }
    }
    return result;
});
